import React, { Component } from "react";
import i18n from "i18n-react";

// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import logo from "assets/images/logo/logo.png";
import { bgImage, baseAppId, storageKeys, points } from "settings";

import APIHandler from "config/APIHandler";
import StorageHandler from "config/StorageHandler";

import PointItem from "components/PointItem";
import ContentHeader from "components/ContentHeader";
import RewardMenu from "components/RewardMenu";

// import { Link } from "react-router-dom";

import "react-toastify/dist/ReactToastify.css";

export default class LeaderboardView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      leaderboardData: [],
      user: [],
      self: 0,
      earnedXp: null,
      dashboardData: [],
      prizeCenterImage: null,
    };
  }

  componentDidMount() {
    this.getLeaderBoardData();
    this.getDashboardData();
    this.getAppData();
  }

  getAppData() {
    APIHandler.getAppInfo(baseAppId).then((res) => {
      // Load prize center
      this.setState({ prizeCenterImage: res.app[0].prize_center_image });
    });
  }

  getLeaderBoardData() {
    StorageHandler.load(storageKeys.user).then((userObj) => {
      if (userObj) {
        const { email } = userObj;
        APIHandler.getLeaderBoard(baseAppId, email).then((res) => {
          console.log(res);
          this.setState({
            leaderboardData: res.top_10,
            self: res.your_position,
            user: res.user,
            earnedXp: res.user.xp,
          });
        });
      }
    });
  }

  getDashboardData() {
    // StorageHandler.load(storageKeys.accessToken).then((token) => {
    //   console.log(token);
    // });
    StorageHandler.load(storageKeys.user).then((userObj) => {
      if (userObj) {
        const { email } = userObj;
        APIHandler.getDashboardItems(
          baseAppId,
          email,
          points.maxSharePoints,
          points.rewardsPoints,
          points.sharePoints,
          points.trainingPoints
        ).then((res) => {
          this.setState({
            dashboardData: res,
          });
        });
      }
    });
  }

  render() {
    const { self, leaderboardData, user, earnedXp, prizeCenterImage } =
      this.state;
    console.log(leaderboardData);
    let users = [];
    if (leaderboardData) {
      users = Object.values(leaderboardData).map((item, i) => {
        const key = i;
        let medal = "none";
        let classPosition = "normal";
        if (i === 0) {
          classPosition = "first";
          medal = "";
        } else if (i === 1) {
          classPosition = "second";
          medal = "silver";
        } else if (i === 2) {
          classPosition = "third";
          medal = "bronze";
        }

        let profileImage =
          "https://profileimagestravpro.imgix.net/empty_profile.jpg?q=50&auto=format&w=80&h=auto";
        if (item.profile_image) {
          profileImage = `https://profileimagestravpro.imgix.net/${item.profile_image}?q=50&auto=format&w=80&h=auto`;
        }

        return (
          <li className={classPosition} key={key}>
            <div className="user">{item.first_name}</div>
            <div className="score">
              {item.points.toLocaleString()}
              <span>pts</span>
            </div>
          </li>
        );
      });
    }

    const { rewardsPoints, trainingPoints, sharePoints, maxTotalPoints } =
      points;

    let getTotalPercentage = Math.ceil((100 / maxTotalPoints) * earnedXp);

    if (getTotalPercentage > 100) {
      getTotalPercentage = 100;
    }

    return (
      <div className="contentContainer BookingForm">
        <RewardMenu />

        <div className="header">
          {/* <Link to="/main">
            <img src={logo} alt="Logo" className="logo" />
          </Link> */}
          <h3>{i18n.translate("rewards.leaderboardScreen.title")}</h3>
        </div>
        <hr />
        <div className="leaderboardView">
          <div className="gradient" />

          {prizeCenterImage !== null && prizeCenterImage !== "" && (
            <div className="prizeWinners">
              <img src={prizeCenterImage} alt="prizeWinners" />
            </div>
          )}
          {(prizeCenterImage === null || prizeCenterImage === "") && (
            <div className="leaderboardHolder">
              <ContentHeader
                header={i18n.translate("contentHeaders.leaderboard")}
                subtitle={i18n.translate("pageDescriptions.leaderboard")}
                icon="trophy"
              />

              <div className="board__holder">
                <div className="list">
                  {users.length > 0 && (
                    <ol className="unranked__User">
                      <h3>
                        {i18n.translate("rewards.leaderboardScreen.earnedpts")}
                      </h3>
                      <li>
                        <div className="position">
                          {self}
                          {"."}
                        </div>
                        <div className="user">{user.first_name}</div>
                        <div className="score">
                          <PointItem points={user.xp} />
                        </div>
                      </li>
                    </ol>
                  )}

                  <h3>
                    {i18n.translate("rewards.leaderboardScreen.pointsWall")}
                  </h3>
                  {users.length === 0 && (
                    <ol>
                      <div className="start">
                        {i18n.translate(
                          "rewards.leaderboardScreen.startEarning"
                        )}
                      </div>
                    </ol>
                  )}
                  {users.length > 0 && <ol>{users}</ol>}
                </div>

                <div className="tentative">
                  <h3>
                    {i18n.translate(
                      "rewards.leaderboardScreen.pointsOverview.title"
                    )}
                  </h3>
                  <ul>
                    <li>
                      {trainingPoints}
                      <span>pts</span>{" "}
                      {i18n.translate(
                        "rewards.leaderboardScreen.pointsOverview.trainingSessions"
                      )}
                    </li>
                    <li>
                      {"50\r"}
                      <span>pts</span> {"Bookings per Night\r"}
                    </li>
                    <li>
                      {sharePoints}
                      <span>pts</span>{" "}
                      {i18n.translate(
                        "rewards.leaderboardScreen.pointsOverview.share"
                      )}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          )}
        </div>
        <div className="bottom__bar" />
      </div>
    );
  }
}
